<template>
    <div class="container">
        <!-- 使用EditDialog组件 -->
        <edit-dialog
            :visible.sync="dialogEditOptions.visible"
            :type="dialogEditOptions.type"
            :keep-login="true"
            :forbid-close="true"
            :message="'为了您的账号安全，请修改默认的密码！'"
            @on-success="handleSuccess"
        />
    </div>
</template>
<script>
import EditDialog from '@/views/profile/components/dialog-edit.vue';

export default {
    name: 'PasswordReset',
    components: {
        EditDialog
    },
    props: {
        userInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            loading: false,
            dialogEditOptions: {
                visible: true,
                type: 'password'
            },
            rules: {
                oldPassword: [
                    { required: true, message: '请输入当前密码', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' },
                    { validator: this.validateNewPassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        // 处理密码修改成功
        handleSuccess() {
            // 密码修改成功后，直接触发成功事件，不退出系统
            this.$emit('on-success');
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    width: 500px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
        font-size: 34px;
        font-weight: 600;
        color: #242424;
        line-height: 34px;
        margin-bottom: 16px;
    }
    .label {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        line-height: 14px;
        margin-bottom: 32px;
    }
    .form {
        width: 335px;
        .btn {
            cursor: pointer;
            width: 100%;
            border: 1px solid #dfe4ed;
            font-size: 16px;
            font-weight: 500;
            color: #2d2f33;
            letter-spacing: 2px;
            border-radius: 4px;
            text-align: center;
            height: 40px;
            line-height: 40px;
            background: transparent;
            margin-bottom: 16px;
            &.btn-primary {
                background: #1890ff;
                color: #fff;
                border-color: #1890ff;
            }
        }
    }
}
</style>